(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const scrim = document.querySelector('[data-cart-scrim]');
  const itemsWrap = document.querySelector('[data-cart-items]');
  const subtotal = document.querySelector('[data-cart-subtotal]');
  const countEls = document.querySelectorAll('[data-cart-count]');

  const money = cents => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  function openCart() {
    drawer?.classList.add('is-open');
    scrim?.classList.add('is-open');
    drawer?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vnx-lock');
  }

  function closeCart() {
    drawer?.classList.remove('is-open');
    scrim?.classList.remove('is-open');
    drawer?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vnx-lock');
  }

  document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', async () => {
    await refreshCart();
    openCart();
  }));
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  scrim?.addEventListener('click', closeCart);

  async function refreshCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }});
    const cart = await res.json();
    countEls.forEach(el => el.textContent = cart.item_count);
    if (subtotal) subtotal.textContent = money(cart.total_price);

    if (!itemsWrap) return;
    if (!cart.items.length) {
      itemsWrap.innerHTML = '<p class="vnx-empty">YOUR CART IS EMPTY.</p>';
      return;
    }

    itemsWrap.innerHTML = cart.items.map(item => `
      <div class="vnx-cart-item" data-line-key="${item.key}">
        <img src="${item.image || ''}" alt="${escapeHtml(item.product_title)}">
        <div>
          <a class="vnx-cart-item-title" href="${item.url}">${escapeHtml(item.product_title)}</a>
          <div class="vnx-cart-item-meta">${item.variant_title && item.variant_title !== 'Default Title' ? escapeHtml(item.variant_title) : ''}</div>
          <div class="vnx-cart-qty">
            <button type="button" data-cart-change data-key="${item.key}" data-qty="${item.quantity - 1}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
          </div><br>
          <button type="button" class="vnx-remove" data-cart-change data-key="${item.key}" data-qty="0">REMOVE</button>
        </div>
        <strong>${money(item.final_line_price)}</strong>
      </div>
    `).join('');

    itemsWrap.querySelectorAll('[data-cart-change]').forEach(btn => {
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: btn.dataset.key, quantity: Number(btn.dataset.qty) })
        });
        await refreshCart();
      });
    });
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'ADDING...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('Unable to add item.');
        await refreshCart();
        openCart();
      } catch (e) {
        alert(e.message);
      } finally {
        btn.disabled = false;
        btn.textContent = original;
      }
    });
  });

  function escapeHtml(str='') {
    return str.replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]));
  }

  // 3D-style falling leaves
  const canvas = document.getElementById('leafCanvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  let leaves = [];

  function resize() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = innerWidth * dpr;
    canvas.height = innerHeight * dpr;
    canvas.style.width = innerWidth + 'px';
    canvas.style.height = innerHeight + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function spawn() {
    leaves.push({
      x: Math.random() * innerWidth,
      y: -35,
      s: 6 + Math.random() * 15,
      vx: -.45 + Math.random() * .9,
      vy: .55 + Math.random() * 1.2,
      r: Math.random() * Math.PI,
      vr: -.03 + Math.random() * .06,
      a: .18 + Math.random() * .35,
      hue: Math.random() > .46 ? 17 : 2
    });
  }

  function drawLeaf(l) {
    ctx.save();
    ctx.translate(l.x, l.y);
    ctx.rotate(l.r);
    ctx.scale(1, .5 + Math.sin(l.r * 2) * .14);
    ctx.beginPath();
    ctx.moveTo(0, -l.s);
    ctx.bezierCurveTo(l.s*.75, -l.s*.25, l.s*.55, l.s*.72, 0, l.s);
    ctx.bezierCurveTo(-l.s*.55, l.s*.72, -l.s*.75, -l.s*.25, 0, -l.s);
    ctx.closePath();
    ctx.fillStyle = `hsla(${l.hue}, 90%, 48%, ${l.a})`;
    ctx.fill();
    ctx.restore();
  }

  function animate() {
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    if (leaves.length < 35 && Math.random() < .24) spawn();
    leaves.forEach(l => {
      l.x += l.vx + Math.sin(l.y * .012) * .25;
      l.y += l.vy;
      l.r += l.vr;
      drawLeaf(l);
    });
    leaves = leaves.filter(l => l.y < innerHeight + 50);
    requestAnimationFrame(animate);
  }

  addEventListener('resize', resize);
  resize();
  animate();
})();